import { render, staticRenderFns } from "./PopupPromotion.vue?vue&type=template&id=0cbb77f8&scoped=true"
import script from "./PopupPromotion.vue?vue&type=script&lang=js"
export * from "./PopupPromotion.vue?vue&type=script&lang=js"
import style0 from "./PopupPromotion.vue?vue&type=style&index=0&id=0cbb77f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb77f8",
  null
  
)

export default component.exports